import React, { useEffect, useState } from 'react';
import RouteConstants from '../../constants/routeConstants';
import { Box, Paper, Typography, Grid, Avatar } from '@mui/material';
import Title from '../../sharedcomponents/title/title';
import { makeStyles } from '@mui/styles';
import Helper from '../../utility/helper';
import ShootingDrills from './Reports/shootingDrills';
import APIHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import AnthroDetails from './Reports/anthroDetails';
import StrengthAgilityDetails from './Reports/strengthAgilityDetails';
import { useEventState } from '../../stores/eventStore';
import { NO_ACCESS_PERMISSION, FULL_PERMISSION } from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import AppConstants from '../../constants/appConstants';

const useStyles = makeStyles((theme) => ({
    profileHeadcontainer: {
        maxWidth: '1440px',
        top: '56px',
        right: 'unset',
        paddingRight: '0 !important',
    },
    paper: {
        height: '500px'
    },
    anthroPaper: {
        height: '200px',
        [theme.breakpoints.only('md')]: {
            height: '260px',
        },
        [theme.breakpoints.only('sm')]: {
            height: '260px',
        },
        [theme.breakpoints.only('xs')]: {
            height: '360px',
        },
    },
    tablesortactivelabel: {
        color: '#fff !important',
    },
    tablesorticon: {
        color: '#fff !important',
    },
    tablesortlabelroot: {
        '&:hover': { color: '#fff !important' },
    },
    loaderContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        bottom: `calc(100vh - 400px)`
    },
    loader: {
        color: '#0c2c75 !important'
    }
}));

const MyStatsReport = (props) => {
    const classes = useStyles();
    const eventInfo = Helper.getStorage('eventInfo');
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const eventState = useEventState();
    const [modPermission, setModPermission] = React.useState(null);
    const [playerData, setPlayerData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (eventInfo.eventID) {
            getEventConfig(eventInfo?.eventID)
        }
    }, [])

    useEffect(() => {
        getDraftCombineData(userInfo?.pcmsPlayerID);
    }, [modPermission])

    const getEventConfig = (eventID) => {
        APIHelper.get(APIURLConstants.GET_EVENT_MENU_CONFIG_LIST(eventID))
            .then((res) => {
                let myStatsReport = res.data && res.data.find(i => i.menuName === AppConstants.EVENT_CONFIG_NAME.MY_STATS);
                setModPermission(myStatsReport?.isActive ? FULL_PERMISSION : NO_ACCESS_PERMISSION);
            }).catch(err => {
                console.log('Error While fetching event config', err);
            })
    }

    const getDraftCombineData = (pcmsPlayerID) => {
        //pcmsPlayerID = 2404;
        if (pcmsPlayerID) {
            const body = {
                "query": `query ExampleQuery($pcmsPlayerId: Int!) {
                    player(pcmsPlayerId: $pcmsPlayerId) {
                      shootingDrills {
                        isAudited
                        noOfMade
                        maxCount
                        percentage
                        region
                        jerseyNumber
                      }
                      id
                      pcmsPlayerId
                      profile {
                        firstName
                        lastName
                        headshotImage
                      }
                      event {
                        id
                        eventId
                        year
                        name
                        description
                        startDate
                        endDate
                      }
                      anthro {
                        id
                        jerseyNumber
                        handLength
                        handWidth
                        heightWithOutShoesFeet
                        heightWithOutShoesInches
                        standingReachFeet
                        standingReachInches
                        bodyWeight
                        wingSpanFeet
                        wingSpanInches
                        isAudited  
                      }
                      strengthAndAgility {
                        isAudited
                        jerseyNumber
                        shuttleRunRightTrialTime
                        shuttleRunLeftTrialTime
                        shuttleRunRightLaserTime
                        shuttleRunLeftLaserTime
                        proLaneTrialTime
                        proLaneTotalLaserTime
                        threeFourRunTime
                        threeFourRunTotalLaserTime
                        maxVerticalInches
                        standingVerticalInches
                      }
                    }
                  }`, "variables": { "pcmsPlayerId": pcmsPlayerID }
            }

            //add below fields in anthro if required to show in Anthro report
            // bodyFat
            // bodyFatDXA
            // hipAbductionPeakForceL
            // hipAbductionPeakForceR
            // hipAbductionRelativeForceL
            // hipAbductionRelativeForceR
            // hipAbductionRelativeForcePercentageDiff
            // hipAdductionPeakForceL
            // hipAdductionPeakForceR
            // hipAdductionRelativeForceL
            // hipAdductionRelativeForceR
            // hipAdductionRelativeForcePercentageDiff
            // kneeExtensionPeakForceL
            // kneeExtensionPeakForceR
            // kneeExtensionRelativeForceL
            // kneeExtensionRelativeForceR
            // kneeExtensionRelativeForcePercentageDiff
            // kneeFlexionPeakForceL
            // kneeFlexionPeakForceR
            // kneeFlexionRelativeForceL
            // kneeFlexionRelativeForceR
            // kneeFlexionRelativeForcePercentageDiff
            // anklePlantarFlexionPeakForceL
            // anklePlantarFlexionPeakForceR
            // anklePlantarFlexionRelativeForceL
            // anklePlantarFlexionRelativeForceR
            // anklePlantarFlexionRelativeForcePercentageDiff

            APIHelper.post(APIURLConstants.GET_MY_STATS_RESULT, body)
                .then(result => {
                    setIsLoading(false);
                    if (result?.data && result?.data?.data && result?.data?.data?.player) {
                        setPlayerData(result?.data?.data?.player)
                    }
                    // console.log('result', result);
                }).catch((err) => {
                    setIsLoading(false);
                    console.log('Error while calling Draft combine API', err);
                });
        }
        else {
            setIsLoading(false);
        }
    }

    return (
        <>
            {(modPermission && modPermission != FULL_PERMISSION) ? (
                <UnauthorizedUI showLogout={false} />
            ) :
                modPermission == FULL_PERMISSION ?
                    <Box sx={{ width: '100%', backgroundColor: '#fafafa' }}>

                        <Box className='contentBox'>
                            <Box style={{ paddingLeft: 20 }}>
                                <Title title={"My Stats"} />
                            </Box>

                            <Box style={{ paddingLeft: 20, paddingBottom: 24, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ display: 'flex', flex: '0 0 auto', marginRight: 2 }}>
                                    <Avatar component={'span'}
                                        sx={{
                                            bgcolor: "#d3d3d3",
                                            width: 60,
                                            height: 60,
                                        }}
                                        src={
                                            playerData && playerData.profile && playerData.profile.headshotImageUrl
                                                ? playerData.profile.headshotImageUrl
                                                : ""
                                        }
                                        alt="userProfile"
                                    ></Avatar>
                                </Box>
                                <Box sx={{ display: 'flex', flex: '1 1 auto', flexDirection: 'column' }}>
                                    <Box>
                                        <Typography variant='h6' color='secondary' component='span'>
                                            {playerData && playerData.profile && playerData.profile.lastName ?
                                                <>
                                                    {
                                                        playerData.profile.lastName + ', ' + playerData.profile.firstName
                                                    }
                                                </>
                                                : ''
                                            }
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant='subtitle2' color='primary' component='span'>
                                            <span>Jersey Number: #</span>
                                            <span>
                                                {
                                                    playerData ?
                                                        (
                                                            playerData.anthro && playerData.anthro.jerseyNumber
                                                                ? playerData.anthro.jerseyNumber
                                                                : playerData.strengthAndAgility && playerData.strengthAndAgility.jerseyNumber
                                                                    ? playerData.strengthAndAgility.jerseyNumber
                                                                    : playerData.shootingDrills && playerData.shootingDrills.length > 0
                                                                        ? playerData.shootingDrills[0].jerseyNumber : ''
                                                        )
                                                        : ''}
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>

                            <div style={{ alignItems: 'center', marginLeft: 24, marginRight: 24, marginTop: 16, marginBottom: 24 }}>
                                <Grid container alignItems={'center'} spacing={2}>

                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                        <Paper variant='elevation' className={classes.anthroPaper} elevation={3}>
                                            <AnthroDetails isLoading={isLoading}
                                                data={playerData ? playerData.anthro : null} />
                                        </Paper>
                                    </Grid>

                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <Paper variant='elevation' className={classes.paper} elevation={3}>
                                            <StrengthAgilityDetails isLoading={isLoading}
                                                data={playerData ? playerData.strengthAndAgility : null} />
                                        </Paper>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <Paper variant='elevation' className={classes.paper} elevation={3}>
                                            <ShootingDrills isLoading={isLoading}
                                                data={playerData ? playerData.shootingDrills : null} />
                                        </Paper>
                                    </Grid>

                                </Grid>
                            </div>
                        </Box>
                        {
                            isLoading &&
                            <div className={classes.loaderContainer}>
                                <CircularProgress color="primary" className={classes.loader} />
                            </div>
                        }
                    </Box>
                    : null
            }
        </>
    )
}

export default
    {
        routeProps: {
            path: RouteConstants.MY_STATS_REPORT,
            component: MyStatsReport,
        },
        name: 'MyStatsReport',
    }
